<template>
<a :href="url" target="_blank">{{content.latitude}}, {{content.longitude}}</a>
</template>

<script>

export default {
	name: "JmGeo",

	props: {
		content: [ Object ]
	},

	computed: {
		url () {
			const lat = this.content.latitude, lon = this.content.longitude
			return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=6/${lat}/${lon}`;
		}
	}

};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Geo.vue